<section class="text-center mt-2">
  <h1>Not Authorized</h1>
  <p>You are not authorized to view this resource. Please contact your administrator or support representive if you believe this is an error.</p>
  <a [routerLink]="['/dashboard']" class="btn btn-primary">Return to Your Dashboard</a>
</section>
